import React, { Component } from 'react'

export default class CustomLink extends Component {

  handleClick=() => {
    this.props.clickLink();
  }

  render() {
    return (
      <div className={this.props.name}>
        <h6
         className='forgot-password-txt'
         onClick={this.handleClick}
        >{this.props.text}</h6>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomLink.js